import React from 'react'
import { Link, useParams } from 'react-router-dom'
import logo from '../../../../assets/images/logo/Haylo-logo-white.png'
import '../style/style.css'
import { FaFacebookF, FaTwitter, FaDownload } from 'react-icons/fa'
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share'
import http from '../../../../config/BaseUrl'
import { useEffect } from 'react'
import { useState } from 'react'
import { IoLogoLinkedin } from 'react-icons/io5'
import { FiMail } from 'react-icons/fi'

function MicrositeDefaultView() {


  const { id } = useParams()
  const [socialShare, setSocialShare] = useState("")

  const fetchSocialGallery = async () => {
    await http.get(`show-gallery-share/${id}`).then((res) => {
      setSocialShare(res.data.share_gallery)
    })
  }
  useEffect(() => {
    fetchSocialGallery()
  }, [])
  // ====================Social Share ======================
  // facebook
  let shareUrl = window.location.href
  let fbUrl = "http://facebook.com"
  // ====================Social Share ======================

  return (
    <div class="Customer-microsite-default">

      <div class="header default-header">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="header-image text-center py-4">
                <img src={logo} class="img-fluid" alt="logo" style={{ width: "250px" }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-body mt-5">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div class="gallery-item-view text-center">
                <div class="gallery-image text-center">
                  <img src="https://picsum.photos/600/400" alt="random-photos" class="img-fluid img-thumbnail" />
                </div>

                <p class="tag-line py-4">Share now with your family and friends</p>

                <ul class="share-option">
                  {socialShare && socialShare.email === 1 && (
                    <li>
                      <EmailShareButton subject="The haylo" body="http://thehaylo.com">
                        <Link to="#" ><FiMail /></Link>
                      </EmailShareButton>
                    </li>
                  )}

                  {socialShare && socialShare.facebook === 1 && (
                    <li>
                      <FacebookShareButton url={shareUrl}
                      // quote={"Hey Share this article"}
                      // hashtag="#React"
                      >
                        <Link to="#"><FaFacebookF /></Link>
                      </FacebookShareButton>
                    </li>
                  )}

                  {socialShare && socialShare.twitter === 1 && (
                    <li>
                      <TwitterShareButton url={shareUrl} >
                        <Link to="#"><FaTwitter /></Link>
                      </TwitterShareButton>
                    </li>
                  )}

                  {socialShare && socialShare.linked_in === 1 && (
                    <li>
                      <LinkedinShareButton url={shareUrl} >
                        <Link to="#"><IoLogoLinkedin /></Link>
                      </LinkedinShareButton>
                    </li>
                  )}

                  {socialShare && socialShare.download === 1 && (
                    <li>
                      <Link to="#" ><FaDownload /></Link>
                    </li>
                  )}

                </ul>

                <Link to="/microsite" class="back-to-gallery">Gallery</Link>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="micro-site-footer">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <p class="text-center footer-name">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
            </div>
          </div>
        </div>
      </div>

    </div>

  )
}

export default MicrositeDefaultView
